import React,{useEffect,useState} from "react";
import {YOUTUBE_VIDEOS_API} from "../utils/constant";
import VideoCard from "./VideoCard";
import {Link} from "react-router-dom";
const VideoContainer=()=>{const[videos,setVideos]=useState([]);useEffect(()=>{fetch(YOUTUBE_VIDEOS_API).then(r=>r.json()).then(j=>setVideos(j.items||[])).catch(()=>setVideos([]));},[]);return <div className="grid grid-cols-1 gap-x-4 gap-y-8 px-4 pb-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5">{videos.map(v=><Link key={v.id} to={"/watch?v="+v.id} className="min-w-0"><VideoCard info={v}/></Link>)}</div>};
export default VideoContainer;
